import type { ComponentContentSchema } from '@vibesites/runtime';
import { contentSchema as baseSchema } from '@vibesites/theme-preferred/components/ReviewsCallout';

/**
 * Dietz Property Group override of the parent ReviewsCallout.
 *
 * Dietz properties currently do not surface a reviews callout on the home
 * page (or anywhere else this slot is placed). Rather than dropping the
 * component from `pages.json` outright — which removes the slot from the
 * registry surface entirely and prevents per-property re-enablement — we
 * keep the slot registered but render nothing.
 *
 * Returning `null` lets the surrounding page flow collapse the section
 * cleanly, while still allowing the slot to appear in the editor's
 * component list and accept content edits if a future property decides
 * to surface reviews via a different mechanism.
 *
 * The schema re-attach is required — `contentSchema` is bound to function
 * identity, and the registry resolves it from `ReviewsCallout.contentSchema`.
 * Re-exporting the parent's schema symbol (rather than re-declaring) ensures
 * future parent edits to tokens/slot groups/collection bindings flow
 * through to this wrapper.
 */
export function ReviewsCallout() {
  return null;
}

(ReviewsCallout as unknown as { contentSchema: ComponentContentSchema }).contentSchema = baseSchema;

export default ReviewsCallout;
